module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-star.7ec7d176.svg";